<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.phase') }} {{ phase }}
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn icon v-bind="attrs" @click="seeMore = !seeMore" v-on="on">
                                    <v-icon v-if="seeMore == true" small>fas fa-caret-down</v-icon>
                                    <v-icon v-else small>fas fa-caret-up</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('tooltips.seeMore') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="seeMore == true">
                            <v-col>
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    fixed-header
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :height="200"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr :class="{'cursor-pointer': true}">
                                            <td>
                                                <v-icon v-if="row.item.global" small>fa-check</v-icon>
                                            </td>
                                            <td>
                                                {{ row.item.rank_display }}
                                            </td>
                                            <td>
                                                {{ row.item.seniority }}
                                            </td>
                                            <td class="font-weight-bold">
                                                {{ row.item.document_type_display }}
                                            </td>
                                            <td>
                                                {{ row.item.document_category_display }}
                                            </td>
                                            <td>
                                                {{ row.item.information }}
                                            </td>
                                            <td>
                                                {{ row.item.remarks }}
                                            </td>
                                            <td v-if="inEditMode">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn
                                                            icon
                                                            v-bind="attrs"
                                                            @click="remove(row.item)"
                                                            v-on="on"
                                                            class="pt-0 mt-0"
                                                        >
                                                            <v-icon small>fas fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.delete') }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-else></td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <td style="width: 7%">
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <CheckBox
                                                        :readonly="!inEditMode"
                                                        v-model="item.global"
                                                        :label="$t('fields.global')"
                                                    ></CheckBox>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col>
                                                    <Dropdown
                                                        :readonly="!rankReadonly"
                                                        v-model="item.rank_id"
                                                        :errorBorder="!itemValidation.rank_id"
                                                        :ajax="true"
                                                        :data="'ranks-abbreviation'"
                                                        :label="$t('fields.rank')"
                                                    ></Dropdown>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col>
                                                    <Dropdown
                                                        :readonly="!seniorityReadOnly"
                                                        v-model="item.seniority"
                                                        :errorBorder="!itemValidation.seniority"
                                                        :ajax="false"
                                                        :data="seniorityList"
                                                        :label="$t('fields.seniority')"
                                                    ></Dropdown>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col>
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="item.document_type_id"
                                                        :errorBorder="!itemValidation.document_type_id"
                                                        :ajax="true"
                                                        :data="'document-types-with-category'"
                                                        :label="$t('fields.documentType')"
                                                    ></Dropdown>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 30%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="item.information"
                                                        :errorBorder="!itemValidation.information"
                                                        :label="$t('fields.information')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 30%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="item.remarks"
                                                        :errorBorder="!itemValidation.remarks"
                                                        :label="$t('fields.remarks')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 3%" v-if="inEditMode">
                                            <v-row dense>
                                                <v-col class="pt-0 mt-0">
                                                    <v-btn
                                                        class="ml-2 mr-2 pt-0 mt-0"
                                                        color="primary"
                                                        @click="saveClick()"
                                                    >
                                                        <v-icon small>fa-save</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td v-else style="width: 3%"></td>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Dropdown from './trinkets/Dropdown';
import CheckBox from './trinkets/CheckBox';
import InputField from './trinkets/InputField';
import DocumentChecklistItem from '../models/DocumentChecklistItem';
export default {
    name: 'DocumentChecklistPhase',
    components: {
        InputField,
        CheckBox,
        Dropdown,
    },
    props: ['phase', 'documentChecklist', 'inEditMode'],
    data: function () {
        return {
            item: new DocumentChecklistItem({}),
            itemValidation: new DocumentChecklistItem({}, true),
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.globalCondition'), sortable: false, width: '7%'},
                {text: this.$t('fields.rank'), sortable: false, width: '10%'},
                {text: this.$t('fields.seniority'), sortable: false, width: '10%'},
                {text: this.$t('fields.documentType'), sortable: false, width: '10%'},
                {text: this.$t('fields.documentCategory'), sortable: false, width: '10%'},
                {text: this.$t('fields.information'), sortable: false, width: '30%'},
                {text: this.$t('fields.remarks'), sortable: false, width: '20%'},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false, width: '3%'},
            ],
            rankReadonly: true,
            seniorityReadOnly: true,
            seeMore: true,
            seniorityList: [
                {value: null, label: 'All'},
                {value: 1, label: '1'},
                {value: 2, label: '2'},
                {value: 3, label: '3'},
                {value: 4, label: '4'},
                {value: 5, label: '5'},
                {value: 6, label: '6'},
                {value: 7, label: '7'},
                {value: 8, label: '8'},
                {value: 9, label: '9'},
                {value: 10, label: '10'},
            ],
        };
    },

    watch: {
        'item.global': {
            handler: function () {
                if (this.item.global == true) {
                    this.item.rank_id = null;
                    this.item.seniority = null;
                    this.rankReadonly = false;
                    this.seniorityReadOnly = false;
                } else {
                    this.rankReadonly = true;
                    this.seniorityReadOnly = true;
                }
            },
            deep: true,
        },
    },

    methods: {
        remove(item) {
            let vm = this;
            let objectId = item.id;
            this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
                if (result) {
                    vm.$APICall('post', 'document-checklist-item-remove/' + objectId, {}, (data, succes) => {
                        if (succes) {
                            this.reloadData();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },

        saveClick() {
            let success = true;
            let missingFields = '';

            if (this.item.global == false) {
                if (this.item.rank_id == null) {
                    success = false;
                    this.itemValidation.rank_id = false;
                    missingFields += this.$t('fields.rank') + '<br/>';
                } else {
                    this.itemValidation.rank_id = true;
                }
            }

            if (this.item.document_type_id == null) {
                success = false;
                this.itemValidation.document_type_id = false;
                missingFields += this.$t('fields.documentType') + '<br/>';
            } else {
                this.itemValidation.document_type_id = true;
            }
            if (success) {
                if (this.documentChecklist.id == 0) {
                    this.$alert(this.$t('alerts.saveDocumentChecklistFirstToAddItems'));
                } else {
                    let vm = this;
                    this.item.document_checklist_id = this.documentChecklist.id;
                    this.item.phase = this.phase;
                    this.$APICall('post', 'document-checklist-items', this.item, (data, succes) => {
                        if (succes) {
                            vm.reloadData();
                            vm.item = new DocumentChecklistItem({});
                            vm.itemValidation = new DocumentChecklistItem({}, true);
                        }
                    });
                }
            } else {
                let alert = this.$t('alerts.missingFields') + '<br/> ' + missingFields;
                this.$alert(alert);
            }
        },

        reloadData() {
            let vm = this;
            let phase = this.phase;
            this.$APICall('get', 'document-checklist-items/' + this.documentChecklist.id, {phase}, (data, success) => {
                if (success) {
                    vm.objectList = data;
                }
            });
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>
